export const forecastFilterCategories = [ "Committed",  "Expected", "Upside", "Pipeline" ]
export const amountFilterCategories = ["Not selected", "From lowest to highest", "From highest to lowest"]
export const closeDateFilterCategories = ["New first", "Old first"]